import {useEffect, useRef} from "react";
import {useApi} from "./useApi";

// State + setter come from the dashboard's single useStorage instance rather
// than a useStorage call here: a second instance would write the shared
// sessionStorage key with its own stale copy of the other slice, clobbering
// the activity saved by useActivity (and vice versa).
const useWatchHistory = ({user, watchHistory, setWatchHistory}) => {
  const {fetchWatchHistory} = useApi();

  const historyRef = useRef(watchHistory);

  useEffect(() => {
    historyRef.current = watchHistory;
  }, [watchHistory]);

  useEffect(() => {
    if (!user?.customer_id && !watchHistory) return;
    fetchWatchHistory(user.customer_id).then(setWatchHistory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {historyRef};
};
export default useWatchHistory;
